<template>
  <div id="box">
    <HeaderView></HeaderView>
    <img
      src="/img/business/images/business_02.jpg"
      alt=""
      class="responsive-img"
    />
    <section class="section1 section-bg fade-in">
      <div class="map-wrapper fade-in">
        <div>
          <h1 class="section-title fade-in">服务覆盖区域</h1>

          <p class="card-desc" v-html="copywriting.kehu"></p>

          <!-- <br>战略,将产品带给全球消费者</p> -->
        </div>

        <!-- <img
          src="/img/business/images/images/map-china2_03.png"
          alt=""
          class="china-map"
        /> -->
        <img
          src="/img/business/images/images/xinmap2.jpg"
          alt=""
          class="china-map"
        />
        <!-- <img src="/img/business/images/china2-map_03.png" alt="" class="china2-map"> -->
        <!-- <div class="flag-item">
                <img class="guo-img" src="/img/business/images/guo1_03.png" alt="">
                <span class="flag-text">国家替代</span>
                <img class="guo-img" src="/img/business/images/guo1_03.png" alt="">
                <span class="flag-text">国家替代</span>
                <img class="guo-img" src="/img/business/images/guo1_03.png" alt="">
                <span class="flag-text">国家替代</span>
            </div> -->
      </div>
    </section>

    <section class="section1 fade-in" style="padding-top: 5rem">
      <h1 class="section-title fade-in">全渠道销售生态体系</h1>
      <div class="business-cards fade-in">
        <div style="margin: 0 auto;">

          <div class="yewu-desc" v-html="copywriting.yewu">
          </div>
          <!-- <div class="qudao-list">
            <div v-for="item in channelList" :key="item.id" class="qudao-item">
              <img :src="item.image" :alt="item.title" class="qudao-icon" />
              <span class="qudao-text">{{ item.title }}</span>
            </div>
          </div> -->
          <p class="yewu-title">【致力于为全球餐饮连锁系统提供高品质食品解决方案】</p>
        </div>

        <!-- <div style="margin: 0 auto;"> 
              <img src="/img/business/images/yewumos.jpg" class="yewu-img" alt="">
            </div> -->
      </div>
      <!-- <div class="img-wrapper fade-in">
            <img style="width:100%;margin:0 auto" src="/img/business/images/bus-img_03.png" alt="">
            <div class="bus-desc">
                <h3 class="card-title2">产品定制化</h3>
                <p class="card-desc2">提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供文字提供</p>
            </div>
          </div> -->
    </section>
    <section class="section2 fade-in">
      <h1 class="section-title fade-in">战略合作伙伴</h1>
      <!-- <div class="logo-grid fade-in">
              <div
                v-for="(item, index) in cooperationList"
                :key="item.id"
                :class="['logo-item', index % 5 === 0 ? 'logo-item1' : index % 5 === 1 ? 'logo-item2' : '']"
              >
                <img
                  :src="item.b_image"
                  :alt="'logo'"
                  @mouseenter="$event.target.src = item.image"
                  @mouseleave="$event.target.src = item.b_image"
                />
              </div>
            </div> -->
      <div class="logo-grid2 fade-in">
        <div
          v-for="(item, index) in cooperationList"
          :key="item.id"
          class="logo-item"
        >
          <img
            :src="item.b_image"
            :alt="'合作伙伴logo'"
            @mouseenter="$event.target.src = item.image"
            @mouseleave="$event.target.src = item.b_image"
          />
        </div>
      </div>
      <img
        src="/img/business/images/bus-end_03.jpg"
        style="width: 85%; margin: 5rem auto 0;border-radius: 1rem;"
        alt=""
        class="fade-in"
      />
    </section>
    <FooterView></FooterView>
  </div>
</template>

<script>
import apiServe from "../services/index.js";
import HeaderView from "../components/HeaderView2.vue";
import FooterView from "../components/FooterView.vue";
export default {
  components: {
    HeaderView,
    FooterView,
  },
  data() {
    return {
      copywriting: {},
      observer: null,
      cooperationList: [],
      channelList: [],
      
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.fetchData();

    // 为logo-item1元素添加hover图片切换效果
    const logoItems = document.querySelectorAll(".logo-item1 img");
    logoItems.forEach((img) => {
      const originalSrc = img.src;
      img.addEventListener("mouseover", () => {
        img.src = "/img/business/images/logo1-c_03.png";
      });
      img.addEventListener("mouseout", () => {
        img.src = originalSrc;
      });
    });
    // 为logo-item2元素添加hover图片切换效果
    const logoItems2 = document.querySelectorAll(".logo-item2 img");
    logoItems2.forEach((img) => {
      const originalSrc = img.src;
      img.addEventListener("mouseover", () => {
        img.src = "/img/business/images/logo2-c_03.png";
      });
      img.addEventListener("mouseout", () => {
        img.src = originalSrc;
      });
    });

    // 添加进入视口动画效果
    const fadeElements = document.querySelectorAll(".fade-in");

    const appearOnScroll = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("appear");
          observer.unobserve(entry.target);
        }
      });
    };

    this.observer = new IntersectionObserver(appearOnScroll, {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    });

    fadeElements.forEach((element) => {
      this.observer.observe(element);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    fetchData() {
      apiServe.getCooperationData({}, "get").then((res) => {
        console.log(res, "我是查询接口返回的数据");
        if (res && res.data) {
          this.cooperationList = res.data;
        }
      });
      apiServe.postChannelData({}, "get").then((res) => {
        console.log(res, "我是查询接口返回的数据");
        if (res && res.data) {
          this.channelList = res.data;
        }
      });
      apiServe.getCopyWriting({}, "get").then((res) => {
       console.log(res, "我是查询接口文案");
        this.copywriting = res.data;
      })
    },
  },
  metaInfo() {
    return {
      title: this.copywriting?.title,
      meta: [
        { name: 'keywords', content: this.copywriting?.keywords },
        { name: 'description', content: this.copywriting?.description}
      ]
    };
  }
};
</script>

<style scoped>
.responsive-img,
img {
  width: 100%;
  height: auto;
  display: block;
}

.section1 {
  padding: clamp(2rem, 5vw, 5rem) clamp(3rem, 10vw, 10rem);
  text-align: center;
  background-image: url(../../public/img/business/images/images/yewu-bg_02.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.section-bg {
  background-image: url(../../public/img/business/images/bg1_02.png);
  background-size: 100%;
  background-repeat: no-repeat;
  /* background-position:100px 100px; */
}
.section2 {
  padding: 5rem clamp(3rem, 10vw, 10rem) clamp(3rem, 10vw, 10rem);
  text-align: center;
  background-image: url(../../public/img/business/images/bus-bg1_02.png);
  background-position-y: -10%;
}
.fade-in {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.fade-in.appear {
  opacity: 1;
  transform: translateY(0);
}

.section-title {
  font-size: clamp(1.8rem, 5vw, 2.8rem);
  text-align: center;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.2em;
}
.map-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  /* max-width: 87%; */
}
.flag-item {
  order: 3;
}
.china-map {
  order: 2;
}
.china2-map {
  order: 1;
}
.china-map {
  margin-top: 2rem;
  /* width: 84%; */
  width: 100%;
  height: auto;
}
.china2-map {
  width: 6%;
  height: auto;
  position: relative;
  top: 15rem;
  left: 10%;
}
.flag-item {
  /* width:100%; */
  height: auto;
}
.flag-item {
  display: flex;
  align-items: center;
  flex-direction: column;
}
/* .guo-img {
    width: 100%;
    height: auto;
  } */
.flag-text {
  margin-top: 0.25rem;
}
.business-cards {
  /* width: 80%; */
  margin: 3rem auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  margin: 0 auto;
  /* text-align: left; */
}
.business-card {
  flex: 1 1 22%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border: 2px solid rgb(148, 147, 147);
  border-radius: 1rem;
  padding: 4rem;
  box-sizing: border-box;
}
.yewu-title {
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.3;
  color: #000;
  letter-spacing: 0.1em;
  /* margin: 6rem 0 0rem 0; */
  text-align: center;
}

.yewu-desc {
  margin: 4rem auto;
  margin-bottom: 0;
  text-align: center;
  /* text-indent: 2rem; */
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 2;
  /* color: #666; */
  /* margin: 4rem 0 0 0; */
  letter-spacing: 0.8px;
}
.qudao-list {
  /* width: 80%; */
  display: flex;
  justify-content: center;
  gap: 2.5rem;
  margin: 2rem 0;
  flex-wrap: wrap;
}
.qudao-item {
  flex: 0 0 calc((75% - 9 * 1rem) / 6);
  display: flex;

  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 3rem 1.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  gap: 1.5rem;
}
.qudao-icon {
  width: 70px;
  height: 70px;
  object-fit: contain;
  margin-bottom: 0.5rem;
}
.qudao-text {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  text-align: center;
  line-height: 1.2;
  letter-spacing: 0.06rem;
}
.yewu-img {
  width: 115%;
  height: auto;
}

.bus-logo {
  width: 70%;
  height: auto;
}
.bus-logo1 {
  width: 50%;
  height: auto;
}
.card-title {
  font-size: 2.8rem;
  font-weight: 500;
  line-height: 1.3;
  color: #000;
  letter-spacing: 0.1em;
  margin: 0 0 0.5rem 0;
}
.card-title2 {
  font-size: 2.8rem;
  font-weight: 500;
  line-height: 1.3;
  color: #ffff;
  letter-spacing: 0.1em;
  margin: 0 0 0.5rem 0;
}
.card-desc {
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1.6;
  color: #666;
  margin-top: 1rem;

}
.card-desc2 {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.6;
  color: #fff;
}
.img-wrapper {
  position: relative;
  width: 80%;
  margin: 0 auto;
}
.bus-desc {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.logo-grid {
  width: 85%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 2rem;
}
.logo-grid2 {
  width: 85%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin-top: 2.5rem;
}

.logo-grid2 .logo-item {
  border: 1px solid rgb(168, 167, 167);
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  box-sizing: border-box;
  width: 10rem;
  height: 5rem;
}

/* 第一行4个元素 (索引0-3) */
.logo-grid2 .logo-item:nth-child(-n + 4) {
  flex: 0 0 calc(20% - 0.75rem);
  width: 10rem;
  /* height: 8rem; */
}

/* 第二行5个元素 (索引4-8) */
.logo-grid2 .logo-item:nth-child(n + 5):nth-child(-n + 9) {
  flex: 0 0 calc(20% - 0.8rem);
  width: 10rem;
  /* height: 8rem; */
}

/* 第三行4个元素 (索引9-12) */
.logo-grid2 .logo-item:nth-child(n + 10):nth-child(-n + 13) {
  flex: 0 0 calc(20% - 0.75rem);
  width: 10rem;
  /* height: 8rem; */
}

/* 第四行5个元素 (索引13-17) */
.logo-grid2 .logo-item:nth-child(n + 14):nth-child(-n + 18) {
  flex: 0 0 calc(20% - 0.8rem);
  width: 10rem;
  /* height: 8rem; */
}

/* 第三行4个元素 (索引18-21) */
.logo-grid2 .logo-item:nth-child(n + 19):nth-child(-n + 22) {
  flex: 0 0 calc(20% - 0.75rem);
  width: 10rem;
  /* height: 8rem; */
}
@media (max-width: 768px) {
  .logo-grid2 .logo-item{
    /* flex: 0 0 calc(33.333% - 0.67rem); */
    padding: 0rem;
    height: 3rem;
  }
  .logo-grid2 {
    width: 100%;
  }
}

/* @media (max-width: 360px) {
    .logo-grid2 .logo-item {
      flex: 0 0 calc(50% - 0.5rem) !important;
    }
  } */
.logo-item img {
  width: 100%;
  /* width: 150px; */
  height: 100%;
  object-fit: contain;
  display: block;
}

@media (max-width: 768px) {
  .section1,
  .section2 {
    padding: 2rem 0.5rem;
  }
  .section-title {
    font-size: clamp(1.8rem, 4vw, 2.5rem);
  }
  .map-wrapper {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  .china-map {
    width: clamp(70%, 80vw, 90%);
    order: 1;
  }
  .china2-map {
    width: clamp(10%, 12vw, 15%);
    top: 0;
    left: 0;
    order: 2;
  }
  .flag-item {
    order: 3;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem 1rem;
    margin-top: 1rem;
    justify-content: center;
    max-width: 80%;
  }
  .flag-item .guo-img {
    width: clamp(1.2rem, 3vw, 1.5rem);
  }
  .flag-text {
    font-size: clamp(0.75rem, 2vw, 0.9rem);
  }
  .business-cards {
    width: 100%;
    flex-direction: column;
    gap: 1rem;
  }
  .business-card {
    flex: 1 1 100%;
    padding: 2rem 1rem;
  }
  .bus-logo {
    max-width: 100%;
    height: auto;
    object-fit: contain;
    max-height: 8rem;
  }
  .bus-logo1 {
    max-width: 100%;
    height: auto;
    object-fit: contain;
    max-height: 8rem;
  }
  .img-wrapper {
    width: 100%;
  }
  .bus-desc {
    width: 90%;
  }
  .card-title2 {
    font-size: clamp(1.1rem, 3vw, 1.3rem);
  }
  .card-desc2 {
    font-size: clamp(0.8rem, 2vw, 0.9rem);
  }
  .qudao-item{
    padding: 1.5rem 1rem;
  }
  .qudao-text{
    font-size: 1rem;
}
.yewu-title {
    font-size: 1.6rem;
  
}
.card-desc {
    font-size: 1rem;
    margin-top: 1rem;

  }
.yewu-desc{
    width: 100%;
    font-size: 1rem;
    margin-top: 1rem;
}
  .logo-grid {
    width: 100%;
    gap: 0.5rem;
  }
  .logo-item {
    flex: 0 0 calc((100% - 1.5rem) / 4);
    width: 8rem;
    height: 6rem;
  }
  .logo-item img {
    width: clamp(70%, 85%, 100%);
  }
  .bus-logo {
    max-width: 100%;
    height: auto;
    object-fit: contain;
    max-height: 8rem;
  }
  .bus-logo1 {
    max-width: 100%;
    height: auto;
    object-fit: contain;
    max-height: 8rem;
  }
}

@media (max-width: 360px) {
  .section1,
  .section2 {
    padding: 1.5rem 0.75rem;
  }
  .section-title {
    font-size: clamp(1.1rem, 5vw, 1.3rem);
  }
  .china-map {
    width: clamp(65%, 75vw, 85%);
  }
  .china2-map {
    width: clamp(8%, 10vw, 12%);
  }
  .flag-item {
    max-width: 90%;
  }
  .flag-item .guo-img {
    width: clamp(1rem, 4vw, 1.2rem);
  }
  .flag-text {
    font-size: clamp(0.7rem, 3vw, 0.8rem);
  }
  .business-card {
    padding: 1.5rem 0.75rem;
  }
  .card-title {
    font-size: clamp(1.2rem, 5vw, 1.4rem);
  }
  .card-desc {
    font-size: clamp(0.8rem, 3vw, 0.9rem);
  }
  .card-title2 {
    font-size: clamp(1rem, 4vw, 1.1rem);
  }
  .card-desc2 {
    font-size: clamp(0.75rem, 3vw, 0.8rem);
  }
  .logo-item {
    flex: 0 0 calc((100% - 1rem) / 3);
    width: 6rem;
    height: 4rem;
  }
  .logo-item img {
    width: clamp(55%, 65%, 75%);
  }
}
</style>
